import { animate, state, style, transition, trigger } from '@angular/animations';

export const drawerAnimations = trigger('slideInOut', [
  state(
    'in',
    style({
      transform: 'translate3d(48px,0,0)',
    })
  ),
  state(
    'out',
    style({
      transform: 'translate3d(-225px, 0, 0)',
    })
  ),
  transition('in => out', animate('300ms ease-in-out')),
  transition('out => in', animate('300ms ease-in-out')),
]);

export const drawerFadeItemsAnimations = trigger('fadeInOut', [
  state(
    'in',
    style({
      opacity: 1,
    })
  ),
  state(
    'out',
    style({
      opacity: 0,
    })
  ),
  transition('in => out', animate('100ms ease-in-out')),
  transition('out => in', animate('100ms ease-in-out')),
]);

export const toggleAnimations = trigger('toggleSlide', [
  state(
    'in',
    style({
      transform: 'translate3d(300px, 0, 0)',
    })
  ),
  state(
    'out',
    style({
      transform: 'translate3d(32px, 0, 0)',
    })
  ),
  transition('in => out', animate('300ms ease-in-out')),
  transition('out => in', animate('300ms ease-in-out')),
]);
